import React, { Fragment, useEffect, useState } from "react";
import QuestionHeading from "./QuestionHeading";
import { RIconCamera, RIconWatch } from "../../../components/Icons";
import { Card, Row } from "react-bootstrap";
import { FormField, FormFieldCheck } from "../../../components/Form/FormField";
const OPTIONS = [{ label: "Nil / NA", value: "Nil" }];
const Q_04 = ({
  dayQuestions,
  register,
  watch,
  setValue,
  reportError,
  trigger,
  isSubmitted,
}) => {
  const [bgClass, setBgClass] = useState("");
  const Q1 = dayQuestions.find((item) => item.id === 36);
  const selectedAns = watch(`questions_${Q1.id}`);
  const selectedCheck1 = watch(`ans_${Q1.id}`);
  useEffect(() => {
    if (selectedAns === "Nil") {
      setValue(`questions_${Q1.id}`, "");
    }
    if (selectedCheck1 === "Nil") {
      setValue(`questions_${Q1.id}`, "Nil");
      trigger(`questions_${Q1.id}`);
    }
    if (selectedAns) {
      setBgClass(selectedAns === "Nil" ? "success" : "danger");
    } else {
      setBgClass("");
    }
  }, [selectedAns, selectedCheck1]);

  const allowOnlyNumbers = (event) => {
    const input = event.target;
    input.value = input.value.replace(/[^0-9]/g, "");
  };

  return (
    <Fragment>
      <Card.Body className={`question-heading px-3 bg-${bgClass}-lt text-dark`}>
        <QuestionHeading
          icon={<RIconCamera className={`text-primary text-${bgClass}`} />}
          number="04"
          title={Q1.subcat}
        />
      </Card.Body>
      <Card.Body className="px-3">
        <Row>
          <FormFieldCheck
            isLabel={false}
            name={`ans_${Q1.id}`}
            register={register}
            options={OPTIONS}
            type="checkbox"
            size="12"
            disabled={isSubmitted}
          />
          <FormField
            label={"Nos. of Exam Centre"}
            name={`questions_${Q1.id}`}
            register={register}
            size="12"
            onInput={allowOnlyNumbers}
            className={`mb-2 ${selectedCheck1 ? "text-transparent" : ""}`}
            disabled={isSubmitted || selectedCheck1}
            error={reportError?.[`questions_${Q1.id}`]}
          />
        </Row>
      </Card.Body>
    </Fragment>
  );
};

export default Q_04;
